module.exports = __webpack_public_path__ + "assets/images/spoke-icon-689abdfcc73a5aef104f6961d81ebacf.png";